/**
 * 更新通知接入处，各端
 * 一期：从系统通知/微信公众号/文档助手点击过来的文档需要弹出toast提示用户谁更新了文档，点击可跳转到修订记录
 */
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { removeURLParameter } from '@src/slide/infrastructure/module/independent/url/param-operation';
import net from 'steamer-net/dist/index';
import { getQuery } from 'sutils';
import i18n from '@i18next/i18n';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IUpdateNoticeManager } from './update-notice-manager.interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { getXSRF } from '@src/slide/domain/slide-app/utils/cookie-utils';

export default class UpdateNoticeManager implements IUpdateNoticeManager {
    public init() {
        const sourceId = getQuery('u_n_source');
        const url = removeURLParameter(window.location.href, 'u_n_source');
        window.history.replaceState(null, '', url); // 从url上删除这个参数
        if (!sourceId) return;
        try {
            const sourceReportMap = {
                1: 'update_notify_tdoc',
                2: 'update_notify_qq',
                3: 'update_notify_app',
                4: 'update_notify_wechat',
            };
            window.tdwReport({
                opername: 'doc_update_notify',
                module: 'doc_update_notify_channe',
                action: sourceReportMap[sourceId],
            });
        } catch (e) {
            // doSomething
        }

        eventBus.on(EventKeys.FIRST_PAGE_DISPLAY, () => { // 首屏加载后再执行
            if (SlideDataServices.DocInfoManager()?.policy !== 2) { // 非查看权限
                this.getModifier()?.then((res) => {
                    this.showSnackbar(res);
                });
            }
        });
    }

    private formatText = (data) => {
        let snackbarText = '';
        for (let index = 0; index < data.oplist.length; index++) {
            const user = data.oplist[index];
            let { nickname } = user;
            if (typeof nickname === 'string') {
                const tempNameLen = nickname.length > 10 ? 10 : nickname.length;
                if (snackbarText.length + tempNameLen > 30) {
                    snackbarText = snackbarText.slice(0, -1);
                    snackbarText = i18n.t('{0}等{1}人修改过该文档。', { 0: snackbarText, 1: data.user_count });
                    break;
                }
                if (nickname.length > 10) {
                    nickname = `${nickname.slice(0, 10)}...`;
                }
                snackbarText = index === data.oplist.length - 1 ? i18n.t('{0}{1}修改过该文档。', { 0: snackbarText, 1: nickname }) : `${snackbarText}${nickname}、`;
            }
        }

        if (browser.isIPad) {
            snackbarText = snackbarText.slice(0, -1);
            snackbarText = `${snackbarText}${i18n.t(`，可在PC端${window.hostname}查看修订记录。`)}`;
        }

        return snackbarText;
    };

    // 获取修改者昵称和人数
    private getModifier() {
        if (window.clientVars) {
            return new Promise((resolve, reject) => {
                net.ajax({
                    url: `//${window.hostname}/cgi-bin/online_docs/oplist_digest_get`,
                    xhrFields: { withCredentials: true },
                    ajaxType: 'get',
                    param: {
                        domain_id: window.clientVars.domainId,
                        pad_id: window.clientVars.padId,
                        // detail_user_num: 2, //返回的修改者人数，默认为2
                        xsrf: getXSRF(),
                    },
                    success: (res) => {
                        if (res.retcode === 0) {
                            resolve(res);
                        } else {
                            reject();
                        }
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
            });
        }
    }

    // 展示弹窗提示
    private showSnackbar = (data) => {
        if (!data.oplist) {
            return;
        }
        const snackbarText = this.formatText(data);
        if (browser.isIPad) {
            import('@tencent/dui/lib/components/Snackbar').then((obj) => {
                const Snackbar = obj.default;
                Snackbar.show({
                    message: snackbarText,
                    autoClose: true,
                    type: 'info',
                    duration: 6000,
                });
            })
                .catch((error) => {
                    window.log.error(`[loadChunk-error]${error}`);
                });
        } else if (browser.isMobile) {
            import('@tencent/dui-mobile/lib/components/Snackbar').then((obj) => {
                const SnackbarMobile = obj.default;
                SnackbarMobile.show({
                    message: snackbarText,
                    autoClose: true,
                    type: 'info',
                    duration: 6000,
                });
            })
                .catch((error) => {
                    window.log.error(`[loadChunk-error]${error}`);
                });
        } else {
            import('@tencent/dui/lib/components/Snackbar').then((obj) => {
                const Snackbar = obj.default;
                Snackbar.show({
                    message: snackbarText,
                    action: i18n.t('查看修订记录'),
                    autoClose: false,
                    closable: true,
                    type: 'info',
                    onClickAction: () => {
                        try {
                            window.tdwReport({
                                opername: 'doc_update_notify',
                                module: 'doc_update_notify_toast',
                                action: 'clk_update_revise',
                            });
                        } catch (e) {
                            window.log.error(`[tdwReport]${e}`);
                        }
                    },
                    onClose: () => {
                        try {
                            window.tdwReport({
                                opername: 'doc_update_notify',
                                module: 'doc_update_notify_toast',
                                action: 'clk_update_close',
                            });
                        } catch (e) {
                            window.log.error(`[tdwReport]${e}`);
                        }
                    },
                });
            })
                .catch((error) => {
                    window.log.error(`[loadChunk-error]${error}`);
                });
        }
    };
}
